import { ITailNumberState, actionTypes } from 'src/ducks/tail-number.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getTailNumberStatus = (
  state: ITailNumberState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
